import React, { useState } from 'react';

const TextArea = ({id, placeholder, onChange, value, error, infoMessage, name = ''}) => {
  const [lostFocus, setLostFocus] = useState(false);

  const onBlurHandler = () => {
    if (!lostFocus) {
      setLostFocus(true);
    }
  };

  const handleChange = (event) => {
    if (event.target.value.length < 2000) {
      onChange(event.target.value);
    }
  };

  return (
    <>
      <textarea
        className={'form-input' + (error && lostFocus ? (' form-input__error') : '')}
        id={id}
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
        onBlur={onBlurHandler}
        name={name}
      />
      {infoMessage &&
      <p className='form-info-message'>{infoMessage}</p>
      }
    </>
  );
};

export default React.memo(TextArea);
